import React, { PureComponent } from "react"

/* PureComponents */
import { Chip } from '../components'

/* Constants */
import { env, utils, sound } from '../constants'

/* Picture */
import { Picture } from "../components"

/* Fields */
const BOXES = [0, 1]


/* Widget Chips */
class Chips extends PureComponent {

    constructor() {
        super()

        this.state = {
            list: []
        }
    }

    setChip = (value, index) => {

        const { ante: anteList, bonus: bonusList, setStake, selected, setSelected, list, setList, balance, game, currency, volume } = this.props

        if (selected !== index) {
            setSelected(index)
            if (volume) {
                sound.play('selectchip', 0.2)
            }
        }
        else {

            let stake = { ante: [...anteList], bonus: [...bonusList] }

            let cnt = 0
            let double = false
            let ante = value

            const activeIndex = stake.ante[1] ? 1 : 0

            let totalAnte = 0
            if (stake.ante) {
                stake.ante.forEach((item, index) => {
                    if (item || index === activeIndex) {
                        ante = item + value
                        totalAnte += ante
                        stake.ante[index] += value
                        cnt += 1
                    }
                })
            }

            if (cnt === 2) {
                double = true
            }

            let totalBonus = 0
            if (stake.bonus) {
                stake.bonus.forEach(item => {
                    totalBonus += item
                })
            }

            if ((totalAnte * 4 + totalBonus) > balance) {
                utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            }
            else if (ante + parseInt(value) > game.max) {
                utils.toggleError(`${utils.translate("Maximum bid")} ${utils.getWithCurrency(game.max, currency)}`, "error", "maxbidante")
            }
            else {
                setStake(stake)

                for (const box of BOXES) {
                    if (stake.ante[box]) {
                        list.push({ value, type: "add", target: "ante", double, box })
                    }
                }

                setList(list)

                if (volume) {
                    sound.play('sound', 0.2)
                }
            }

        }

    }

    clear = () => {

        const { ante, setStake, setList, volume } = this.props

        if (utils.valueLength(ante)) {

            setStake({ ante: [0, 0], bonus: [0, 0] })
            setList([])

            if (volume) {
                sound.play('chip2', 0.2)
            }
        }

    }

    cancel = () => {

        const { ante, bonus, setStake, list, setList, volume } = this.props
        let cancel = list

        const index = list.findLastIndex(e => e.type === "add")

        if (index > -1) {

            const last = list[index]
            let stake = { ante: [...ante], bonus: [...bonus] }

            if (last.refresh) {
                setList([])
                setStake({ ante: [0, 0], bonus: [0, 0] })
                return
            }

            if (last.target === 'ante') {
                if (stake.ante[last.box] - last.value >= 0) {
                    stake.ante[last.box] -= last.value
                    list[index].type = "remove"
                }
                if (last.double) {
                    const secondBox = last.box ? 0 : 1
                    if (stake.ante[secondBox] && stake.ante[secondBox] - last.value >= 0) {
                        stake.ante[secondBox] -= last.value
                        const ind = list.findLastIndex(e => e.type === "add" && e.target === "ante" && e.box === secondBox && e.double)
                        if (ind !== -1) {
                            list[ind].type = "remove"
                        }
                    }
                }
            }
            if (last.target === 'bonus') {
                if (stake.bonus[last.box] - last.value >= 0) {
                    stake.bonus[last.box] -= last.value
                    const ind = list.findLastIndex(e => e.type === "add" && e.target === "bonus")
                    list[ind].type = "remove"
                }
            }

            setStake(stake)
            setList(cancel)

            if (volume) {
                sound.play('chip2', 0.2)
            }
        }
    }

    double = () => {

        const { ante: anteList, bonus: bonusList, setStake, list, setList, balance, game, currency, volume } = this.props

        let count = 0

        let stake = { ante: [...anteList], bonus: [...bonusList] }

        let cnt = 0
        let double = false
        let ante = 0
        let value = 0

        let totalAnte = 0
        if (stake.ante) {
            stake.ante.forEach((item, index) => {
                if (item) {
                    cnt += 1
                    totalAnte = totalAnte + item
                    ante = stake.ante[index] + item
                    stake.ante[index] += item
                    value = item
                }
            })
        }

        if (cnt === 2) {
            double = true
        }

        let totalBonus = 0
        if (stake.bonus) {
            stake.bonus.forEach(item => {
                totalBonus = totalBonus + item
            })
        }

        if ((totalAnte * 8 + totalBonus) > balance) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        if (ante > game.max) {
            utils.toggleError(`${utils.translate("Maximum bid")} ${utils.getWithCurrency(game.max, currency)}`, "error", "maxbidante")
            return
        }

        setStake(stake)

        for (const box of BOXES) {
            if (stake.ante[box]) {
                list.push({ value, type: "add", target: "ante", double, box })
            }
        }

        setList(list)
        count = count + 1

        if (volume && count > 0) {
            sound.play('sound', 0.2)
        }

    }


    refresh = () => {

        const { ante: anteList, last: lastList, setStake, list, setList, balance, volume } = this.props

        let count = 0

        let stake = { ante: [0, 0], bonus: [0, 0] }

        for (const box of BOXES) {

            const ante = utils.check(anteList[box], 0)
            const last = utils.check(lastList[box], 0)

            let totalAnte = 0
            let totalBonus = 0

            if (lastList) {
                lastList.forEach((item, index) => {
                    if (item.ante) {
                        totalAnte = totalAnte + item.ante
                        totalBonus = totalBonus + item.bonus
                        stake.ante[index] = item.ante
                        stake.bonus[index] = item.bonus
                    }
                })
            }

            if (ante === 0 && (last && last.ante > 0)) {

                if (totalAnte * 4 + totalBonus > balance) {
                    utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
                    return
                }

                setStake(stake)

                if (last.ante) {
                    list.push({ value: last.ante, type: "add", target: "ante", refresh: true, box })
                }
                if (last.bonus) {
                    list.push({ value: last.bonus, type: "add", target: "bonus", refresh: true, box })
                }

                setList(list)
                count = count + 1
            }
        }

        if (volume && count > 0) {
            sound.play('repeat', 0.2)
        }
    }

    render = () => {

        const { selected, ante, last, chips } = this.props

        let total = 0
        if (last && Array.isArray(last) && last.length > 0) {
            last.forEach(item => {
                if (item.ante && parseFloat(item.ante) > 0) {
                    total = total + parseFloat(item.ante)
                }
            })
        }

        const isRefresh = utils.valueLength(ante) === 0 && total > 0
        const btnStyle = utils.valueLength(ante) > 0 ? { opacity: 1 } : { opacity: 0.5, cursor: 'default' }
        const refreshStyle = isRefresh ? { opacity: 1 } : { opacity: 0.5, cursor: 'default' }

        return (
            <div className="chips-container">

                <div onClick={() => this.clear()} className="chips-button" style={btnStyle}>
                    <Picture src={`${env.mediapoint}/images/delete.png`} alt="Delete" />
                    {utils.translate('Clear')}
                </div>

                <div onClick={() => this.cancel()} className="chips-button" style={btnStyle}>
                    <Picture src={`${env.mediapoint}/images/cancel.png`} alt="Cancel" />
                    {utils.translate('Cancel')}
                </div>

                <div className="chips-box">
                    {chips.map((chip, index) =>
                        <div onClick={() => this.setChip(chip.value, index)} key={`${index}`} className={`chip ${selected === index ? 'active' : 'disabled'}`}>
                            <Chip color={chip.color} value={chip.value} />
                        </div>
                    )}
                </div>

                <div onClick={() => this.double()} className="chips-button" style={btnStyle}>
                    <span>2x</span>
                    {utils.translate('Double')}
                </div>

                <div onClick={() => isRefresh && this.refresh()} className="chips-button" style={refreshStyle}>
                    <Picture src={`${env.mediapoint}/images/refresh.png`} alt="Refresh" />
                    {utils.translate('Repeat')}
                </div>

            </div>
        )
    }

}

export default Chips